
const cabinetCommissionsType = {
  CABINET_COMMISSIONS_TABLE_STATE_SET: 'CABINET_COMMISSIONS/TABLE_STATE_SET',
  CABINET_COMMISSIONS_TABLE_STATE_RESET: 'CABINET_COMMISSIONS/TABLE_STATE_RESET',
};
export default cabinetCommissionsType;
